import { useState, useEffect } from 'react';
import { pageSeoAPI } from '../../services/api';

const PAGE_TYPES = [
    { value: 'home', label: 'Ana Sayfa' },
    { value: 'products', label: 'Ürünler Sayfası' },
    { value: 'about', label: 'Hakkımızda' },
    { value: 'contact', label: 'İletişim' },
    { value: 'blog', label: 'Blog Listesi' },
    { value: 'services', label: 'Hizmetler' },
    { value: 'category', label: 'Kategori Detay' },
    { value: 'product', label: 'Ürün Detay' },
    { value: 'blog-detail', label: 'Blog Detay' },
    { value: 'service-detail', label: 'Hizmet Detay' },
    { value: 'corporate', label: 'Kurumsal Sayfa' },
    { value: 'custom', label: 'Özel Sayfa' },
];

export default function PageSeoAdmin() {
    const [seoList, setSeoList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [form, setForm] = useState({
        pageType: 'home', pageSlug: '', seoTitle: '', seoDescription: '',
        seoKeywords: '', ogImage: '', canonicalUrl: '', isActive: true
    });
    const [formBusy, setFormBusy] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await pageSeoAPI.getAll();
            setSeoList(res.data?.data || res.data || []);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { fetchData(); }, []);

    const openCreate = () => {
        setEditItem(null);
        setForm({ pageType: 'home', pageSlug: '', seoTitle: '', seoDescription: '', seoKeywords: '', ogImage: '', canonicalUrl: '', isActive: true });
        setShowModal(true);
    };

    const openEdit = (item) => {
        setEditItem(item);
        setForm({
            pageType: item.pageType || 'home', pageSlug: item.pageSlug || '',
            seoTitle: item.seoTitle || '', seoDescription: item.seoDescription || '',
            seoKeywords: item.seoKeywords || '', ogImage: item.ogImage || '',
            canonicalUrl: item.canonicalUrl || '', isActive: item.isActive
        });
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormBusy(true);
        try {
            if (editItem) {
                await pageSeoAPI.createOrUpdate({ ...form, id: editItem.id });
            } else {
                await pageSeoAPI.createOrUpdate(form);
            }
            setShowModal(false);
            fetchData();
        } catch (err) {
            alert(err.response?.data?.error || 'Hata oluştu');
        }
        setFormBusy(false);
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu SEO kaydını silmek istediğinize emin misiniz?')) return;
        try { await pageSeoAPI.delete(id); fetchData(); } catch (err) { alert('Silinemedi'); }
    };

    const getPageTypeLabel = (type) => PAGE_TYPES.find(p => p.value === type)?.label || type;

    return (
        <div>
            <div className="admin-header">
                <h1>Sayfa SEO Yönetimi</h1>
                <button className="btn btn-primary" onClick={openCreate}>+ SEO Kaydı Ekle</button>
            </div>

            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '1rem' }}>
                Her sayfa için ayrı ayrı SEO başlık, açıklama, anahtar kelimeler ve Open Graph ayarlarını yönetin.
            </p>

            {loading ? <div className="loading"><div className="spinner"></div></div> : (
                <div className="data-table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Sayfa Tipi</th>
                                <th>Slug</th>
                                <th>SEO Başlık</th>
                                <th>Durum</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {seoList.map(item => (
                                <tr key={item.id}>
                                    <td style={{ fontWeight: 600 }}>{getPageTypeLabel(item.pageType)}</td>
                                    <td style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{item.pageSlug || '-'}</td>
                                    <td style={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.seoTitle || <span style={{ color: 'var(--text-muted)' }}>Belirtilmemiş</span>}
                                    </td>
                                    <td>
                                        <span className={`stock-badge ${item.isActive ? 'stock-in' : 'stock-out'}`}>
                                            {item.isActive ? 'Aktif' : 'Pasif'}
                                        </span>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                                            <button className="btn-icon" onClick={() => openEdit(item)}>✏️</button>
                                            <button className="btn-icon" onClick={() => handleDelete(item.id)} style={{ color: 'var(--danger)' }}>🗑️</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {seoList.length === 0 && (
                                <tr><td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Henüz SEO kaydı eklenmemiş</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowModal(false)}>
                    <div className="modal" style={{ maxWidth: 600 }}>
                        <div className="modal-header">
                            <h2>{editItem ? 'SEO Düzenle' : 'Yeni SEO Kaydı'}</h2>
                            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>Sayfa Tipi *</label>
                                        <select className="form-control" value={form.pageType} onChange={e => setForm({ ...form, pageType: e.target.value })}>
                                            {PAGE_TYPES.map(pt => <option key={pt.value} value={pt.value}>{pt.label}</option>)}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Sayfa Slug'ı</label>
                                        <input className="form-control" value={form.pageSlug} onChange={e => setForm({ ...form, pageSlug: e.target.value })} placeholder="ör: hakkimizda" />
                                        <small style={{ color: 'var(--text-muted)' }}>Detay sayfaları için zorunlu</small>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>SEO Başlık</label>
                                    <input className="form-control" value={form.seoTitle} onChange={e => setForm({ ...form, seoTitle: e.target.value })} placeholder="Sayfa başlığı | Site Adı" />
                                    <small style={{ color: form.seoTitle.length > 60 ? 'var(--danger)' : 'var(--text-muted)' }}>
                                        {form.seoTitle.length}/60 karakter
                                    </small>
                                </div>
                                <div className="form-group">
                                    <label>SEO Açıklama (Meta Description)</label>
                                    <textarea className="form-control" rows={3} value={form.seoDescription} onChange={e => setForm({ ...form, seoDescription: e.target.value })} placeholder="Sayfa açıklaması..." />
                                    <small style={{ color: form.seoDescription.length > 160 ? 'var(--danger)' : 'var(--text-muted)' }}>
                                        {form.seoDescription.length}/160 karakter
                                    </small>
                                </div>
                                <div className="form-group">
                                    <label>SEO Anahtar Kelimeler</label>
                                    <input className="form-control" value={form.seoKeywords} onChange={e => setForm({ ...form, seoKeywords: e.target.value })} placeholder="anahtar, kelimeler, virgülle" />
                                </div>
                                <div className="form-group">
                                    <label>OG Image URL</label>
                                    <input className="form-control" value={form.ogImage} onChange={e => setForm({ ...form, ogImage: e.target.value })} placeholder="Sosyal medya paylaşım görseli URL'si" />
                                </div>
                                <div className="form-group">
                                    <label>Canonical URL</label>
                                    <input className="form-control" value={form.canonicalUrl} onChange={e => setForm({ ...form, canonicalUrl: e.target.value })} placeholder="https://..." />
                                </div>
                                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input type="checkbox" checked={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.checked })} id="seo-active" />
                                    <label htmlFor="seo-active" style={{ cursor: 'pointer', margin: 0 }}>Aktif</label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                                <button type="submit" className="btn btn-primary" disabled={formBusy}>
                                    {formBusy ? 'Kaydediliyor...' : (editItem ? 'Güncelle' : 'Kaydet')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
